<template>
  <div>
    <div class="food_menu">
      <ul>
        <FoodMenuItem :active="active" name="burgers" url="/menu/burgers" />

        <FoodMenuItem :active="active" name="burgerbowls" url="/menu/burger_bowls" />

        <FoodMenuItem :active="active" name="sandwiches" url="/menu/sandwiches" />

        <FoodMenuItem :active="active" name="hotdogs" url="/menu/hot_dogs" />

        <FoodMenuItem :active="active" name="salads" url="/menu/salads" />

        <FoodMenuItem :active="active" name="seafood" url="/menu/seafood" />

        <FoodMenuItem :active="active" name="kids" url="/menu/kids" />

        <FoodMenuItem :active="active" name="sides" url="/menu/sides" />

        <FoodMenuItem :active="active" name="shakes" url="/menu/shakes" />

        <FoodMenuItem
          :active="active"
          name="beverages"
          url="/menu/beverages"
          style="position: relative; z-index: 10;"
        />
      </ul>
    </div>

    <div class="over_menu">
      <a href="https://jeffreyshamburgers.alohaorderonline.com/">
        <img src="assets/images/clr.png" style="width:198px; height:68px;" />
      </a>
    </div>
  </div>
</template>

<script>
import FoodMenuItem from './FoodMenuItem.vue';

export default {
  name: 'TheFoodMenu',

  components: {
    FoodMenuItem,
  },

  props: {
    active: {
      type: String,
      required: false,
    },

  },

  methods: {
    classes(menuItem) {
      return this.active === menuItem ? `active ${menuItem}` : menuItem;
    },
  },
};
</script>

<style>
.food_menu .menu-item {
  background: linear-gradient(90deg,rgba(47, 47, 49, 1) 0%, rgba(53, 53, 55, 1) 100%);
}
</style>
